import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { List } from 'immutable'

import { getActiveNoteId } from 'data/ui/selectors'
import { getNote } from 'data/notes/selectors'
import { getCurrentUserId, getAllUsers } from 'data/users/selectors'

import { TooltipOnHover } from 'components/Utils/TooltipOnHover'

const AUDIENCES = {
  NONE: '',
  MENTIONED: '(mentioned)',
  NOTE_AUTHOR: '(doc author)',
  NOTE_CONTRIBUTORS: '(doc contributors)',
  THREAD_AUTHOR: '(thread author)',
  THREAD_CONTRIBUTORS: '(thread contributors)',
}

class NotificationAudienceHelper extends Component {
  static propTypes = {
    mentionIds: PropTypes.array.isRequired,
    threadSubscriberIds: PropTypes.instanceOf(List),
  }

  getNotificationAudience = () => {
    const {
      mentionIds,
      currentUserId,
      startOfThread,
      note,
      threadSubscriberIds,
      allUsers,
    } = this.props
    let notifiedIds = []
    let audienceType = AUDIENCES.NONE
    const filteredMentionIds = mentionIds.filter(id => id !== currentUserId)
    if (filteredMentionIds.length > 0) {
      // if (filteredMentionIds) we take them
      notifiedIds = filteredMentionIds
      audienceType = AUDIENCES.MENTIONED
    } else if (startOfThread) {
      // If start of thread & no mention --> we notify the note subscribers
      notifiedIds = note
        .get('writerIds')
        .filter(id => id !== currentUserId)
        .toArray()
      audienceType =
        notifiedIds.length > 1
          ? AUDIENCES.NOTE_CONTRIBUTORS
          : AUDIENCES.NOTE_AUTHOR
    } else {
      // reply to a thread with no mention
      notifiedIds = threadSubscriberIds
        .filter(id => id !== currentUserId)
        .toArray()
      audienceType =
        notifiedIds.length > 1
          ? AUDIENCES.THREAD_CONTRIBUTORS
          : AUDIENCES.THREAD_AUTHOR
    }
    const notifiedUsernames = allUsers
      .filter(u => notifiedIds.includes(u.id))
      .map(u => u.get('username'))
      .toArray()
    return { audienceType, notifiedUsernames }
  }

  render() {
    const { notifiedUsernames, audienceType } = this.getNotificationAudience()
    const usernamesLabel = notifiedUsernames.reduce(
      (memo, name) => `${memo} @${name}`,
      ''
    )
    return (
      <div className="flexbox-grow flexbox-align-center shade-20 line-height-larger">
        {notifiedUsernames.length === 0 ? (
          <span>Nobody</span>
        ) : (
          <TooltipOnHover
            id="thread-notifier"
            placement="top"
            tooltipContent={`${usernamesLabel} ${audienceType}`}
          >
            <span className="shade-05 font-weight-medium">
              {notifiedUsernames.length === 1
                ? usernamesLabel
                : `${notifiedUsernames.length} people`}
            </span>
          </TooltipOnHover>
        )}

        {' will be notified.'}

        <TooltipOnHover
          id="thread-notifier-add"
          placement="top"
          tooltipContent={'Type “@” + username to notify someone.'}
        >
          <span className="shade-05 margin-left-smaller font-weight-medium ">
            {audienceType !== AUDIENCES.MENTIONED ? 'Change?' : 'Add others?'}
          </span>
        </TooltipOnHover>
      </div>
    )
  }
}

export default connect(state => {
  const noteId = getActiveNoteId(state)
  const note = getNote(state, noteId)
  const currentUserId = getCurrentUserId(state)
  const allUsers = getAllUsers(state)

  return {
    currentUserId,
    note,
    allUsers,
  }
})(NotificationAudienceHelper)
